import EngineCleanupBase from '../../../services/engines/EngineCleanupBase';
import componentNotifier from '../../../services/wss/ComponentNotifier';
import csCodeGenConfigCache from './CsCodeGenConfigCache';
import csCodeGenConfigFetcher from './CsCodeGenConfigFetcher';
import { EngineNames } from '../../../services/wss/events/EngineNames';
import csCodeGenFormData from './CsCodeGenFormData';

const _name = EngineNames.CsCodeGenConfigEngine;

class CsCodeGenConfigEngine extends EngineCleanupBase {
    //
    // the selected CsCodeGen config from LoadCsCodeGenConfigDlg
    _selected = csCodeGenFormData.createDefault();

    /**
     * initialize engine
     */
    bootup = () => {
        this.initialize(_name);
    };

    /**
     * fetch all CsCodeGen config notes from BE
     */
    fetchAll = async () => {
        await csCodeGenConfigFetcher.fetch();
    };

    /**
     * set the selected config note
     * @param {*} entry the selected CsCodeGen config note
     */
    setSelected = (entry) => {
        try {
            this._selected = entry;
            this._notify();
        } catch (error) {
            this.logError('setSelected', error.message);
        }
    };

    getSelected = () => {
        return this._selected;
    };

    /**
     * update CsCodeGen config notes in cache — same pattern as every other engine:
     * type-filter, cache addOrUpdate, notify.
     * @param {*} entries the updated entries from BE from SignalR
     * @returns
     */
    onJournalUpdated = (entries) => {
        try {
            if (!Array.isArray(entries) || !entries.length) {
                return false;
            }

            const items = entries.filter((x) => x.type === 'CsCodeGenConfig');
            if (items.length === 0) {
                return;
            }

            const configs = [];

            items.forEach((x) => {
                const cfg = JSON.parse(x.body);
                cfg.rk = x.rk;

                configs.push(x);
            });

            csCodeGenConfigCache.addOrUpdate(configs);

            this._notify();
            return true;
        } catch (error) {
            this.logError('onJournalUpdated', error.message);
            return false;
        }
    };

    /**
     * Called directly from PageContentSRHandlers on OnJournalDeleted.
     * @param {string} rk
     */
    onJournalDeleted = (rk) => {
        try {
            if (!rk) {
                this.logError('onJournalDeleted', `Invalid row key - ${rk}`);
                return false;
            }

            const deleted = csCodeGenConfigCache.delete(rk);
            if (!deleted) {
                return;
            }

            this._notify();

            return deleted;
        } catch (error) {
            this.logError('onJournalDeleted', error.message);
            return false;
        }
    };

    // ─── private ──────────────────────────────────────────

    _notify = () => {
        componentNotifier.notify(_name, 'dataChanged', {
            items: csCodeGenConfigCache.getAll(),
            selected: this._selected,
        });
    };

    clear = () => {
        csCodeGenConfigCache.clear();
        super.clear();
    };
}

const csCodeGenConfigEngine = new CsCodeGenConfigEngine();
export default csCodeGenConfigEngine;
